import { render, staticRenderFns } from "./InputText.vue?vue&type=template&id=5c1c4df0&scoped=true&"
import script from "./InputText.vue?vue&type=script&lang=ts&"
export * from "./InputText.vue?vue&type=script&lang=ts&"
import style0 from "./InputText.vue?vue&type=style&index=0&id=5c1c4df0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1c4df0",
  null
  
)

export default component.exports